<template>
    <div class="row row-wider">
        <div class="col-md-12" style="min-height: 150px;">
            <form @submit.prevent="submit" class="form-horizontal">
                <v-client-table ref="siteTable" :data="siteList" :columns="siteListGridSpec.columns" :options="siteListGridSpec.options">
                    <template slot="effect" slot-scope="props">
                        <div v-if="!formDisabled">
                            <select class="form-control" v-model="props.row.effectId" v-on:change="setEffect(props.row.culturalResourceId, $event, 'effectId')">
                                <option value="" disabled>Select a value</option>
                                <option v-for="effect in effectList" v-bind:value="effect.effectId" v-bind:key="effect.effectId">
                                    {{ effect.description }}
                                </option>
                            </select>
                        </div>
                        <div v-else>
                            {{ (effectList.find(x => x.effectId === props.row.effectId) || { description: '' }).description }}
                        </div>
                    </template>
                    <template slot="shpoEffect" slot-scope="props">
                        <div v-if="isShpo">
                            <select class="form-control" v-model="props.row.shpoEffectId" v-on:change="setEffect(props.row.culturalResourceId, $event, 'shpoEffectId')">
                                <option value="" disabled>Select a value</option>
                                <option v-for="effect in effectList" v-bind:value="effect.effectId" v-bind:key="effect.effectId">
                                    {{ effect.description }}
                                </option>
                            </select>
                        </div>
                        <div v-else>
                            {{ (effectList.find(x => x.effectId === props.row.shpoEffectId) || { description: '' }).description }}
                        </div>
                    </template>
                    <template slot="delete" slot-scope="props">
                        <div style="text-align: center" v-if="!formDisabled">
                            <a class="fa fa-ban" style="font-size: 18px;" v-on:click="deleteResource(props.row)"></a>
                        </div>
                    </template>
                </v-client-table>
                <div class="form-group">
                    <label class="col-md-2 control-label">&nbsp;</label>
                    <div class="col-md-4">
                        <div v-show="crrValidationResult && crrValidationResult.messages && crrValidationResult.messages.length > 0">
                            <span class="has-error">Error on delete:</span>
                            <ul class="has-error">
                                <li v-for="message in crrValidationResult.messages" v-bind:key="message">{{ message }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div  class="col-md-12">
                    <button v-if="!formDisabled || isShpo" class="btn btn-primary pull-left" v-on:click="save()">Save</button>
                    <button v-if="!formDisabled" type="button" class="btn btn-primary form-control pull-right" style="width:95px" v-on:click="showSearch()">Add New</button>
                </div>
            </form>
            <modal  ref="culturalResourceSearchModal">
                <h3 slot="header">Cultural Resource Search</h3>
                <div slot="body">
                    <div class="form form-horizontal">
                        <div class="">
                            <div class="form-group">
                                <label class="col-md-4 control-label">Smithsonian Number</label>
                                <div class="col-md-8">
                                    <input type="text" class="form-control" v-model="crSearchDto.smithsonianNumber" autocomplete="off">
                                </div>
                            </div>
                        </div>
                        <div class="">
                            <div class="form-group">
                                <label class="col-md-4 control-label">Site Name</label>
                                <div class="col-md-8">
                                    <input type="text" class="form-control" v-model="crSearchDto.siteName" autocomplete="off">
                                </div>
                            </div>
                        </div>
                        <div class="" v-if="isAdmin">
                            <div class="form-group">
                                <div class="col-md-1"></div>
                                <div class="col-md-8">
                                    <label class="control-label text-label" for="crShowInactive">Show Inactive</label>
                                    <input type="checkbox" v-model="crSearchDto.showInactive" class="form-check-input" id="crShowInactive" style="width: 15px; height: 15px;"/>
                                </div>
                            </div>
                        </div>
                        <loader v-if="crSearchLoading"></loader>
                        <div v-if="searchGridSpec.tableData.length > 0" class="well">
                            <v-client-table :data="searchGridSpec.tableData" :columns="searchGridSpec.columns" :options="searchGridSpec.options">
                                <template slot="add" slot-scope="props">
                                    <div style="text-align: center">
                                        <a class="fa fa-plus" style="font-size: 18px;" v-on:click="addCulturalResource(props.row)"></a>
                                    </div>
                                </template>
                            </v-client-table>
                        </div>
                        <div v-if="noSearchResults">
                            No Cultural Resources found
                        </div>
                    </div>
                </div>
                <div slot="footer">
                    <div class="row">
                        <button name="buttonSearch" class="btn btn-primary col-md-3" v-on:click="searchCulturalResource()"> Search </button>
                        <button name="buttonCancel" class="btn btn-primary col-md-3" v-on:click="$refs['culturalResourceSearchModal'].close()"> Cancel </button>
                    </div>
                </div>
            </modal>
        </div>
        <div v-if="isDebug">
            <h2>**Debug**</h2>
            {{siteList}}
        </div>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import evaluationService from '../services/siteForm/evaluationService'
import undertakingService from '../services/undertakingService'
import culturalResourceService from '../services/culturalResourceService'
import modal from '../components/Modal.vue'
import loader from '../components/Loader.vue'
import { tab, tabs } from 'vue-strap'
import {ServerTable, ClientTable, Event} from 'vue-tables-2'
import { mapState } from 'vuex'
import roleService from '@/services/roleService'
import userService from '@/services/userService'

export default {
    components: {
        modal,
        loader,
        tabs,
        tab,
        serverTable: ServerTable,
        clientTable: ClientTable,
        event: Event
    },
    data: function () {
        return {
            isDebug: false,
            CRSelectionUndertakingLoading: true,
            crSearchDto: {},
            crSearchLoading: false,
            noSearchResults: true,
            effectList: evaluationService.EffectList,
            siteList: [],
            siteListGridSpec: {
                columns: ['smithsonianNumber', 'siteName', 'eligibilityDescription', 'timePeriodDescription', 'siteTypeDescription', 'effect', 'shpoEffect', 'delete'],
                options: {
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        smithsonianNumber: 'Smithsonian Number',
                        siteName: 'Site Name',
                        eligibilityDescription: 'Eligibility',
                        timePeriodDescription: 'Time Period',
                        siteTypeDescription: 'Site Type',
                        effect: 'Effect',
                        shpoEffect: 'SHPO Effect',
                        delete: 'delete'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'siteName'
                    }
                }
            },
            searchGridSpec: {
                columns: ['smithsonianNumber', 'siteName', 'add'],
                options: {
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    headings: {
                        smithsonianNumber: 'Smithsonian Number',
                        siteName: 'Site Name',
                        add: 'Add'
                    }

                },
                tableData: []
            },
            crrValidationResult: {}
        }
    },
    computed: {
        isNew: function () {
            return (!this.undertaking || !this.undertaking.undertakingId)
        },
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        isAdmin: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.Administrator, roleService.RoleEnum.ShpoAdministrator])
        }
    },
    props: {
        undertaking: {},
        isShpo: { default: false },
        loadOnMount: { default: true },
        formDisabled: { default: false }
    },
    mounted () {
        loggingService.log(this.isDebug, 'CRSelectionUndertaking', 'mounted for projectId ' + this.$route.query.projectId)
        if (this.loadOnMount) this.loadData()
    },
    watch: {
        undertaking: function (val) {
            loggingService.log(this.isDebug, 'CRSelectionUndertaking', 'Undertaking changed, reloading')
            this.loadSelectionList()
        }
    },
    methods: {
        loadData () {
            Promise.all([this.loadSelectionList()]).then(response => {
                loggingService.log(this.isDebug, 'CRSelectionUndertaking', 'Done with all loading')
                this.CRSelectionUndertakingLoading = false
            })
        },
        loadSelectionList () {
            loggingService.log(this.isDebug, 'CRSelectionUndertaking', 'Loading selectionList for undertaking ID ' + this.undertaking.undertakingId)
            if (this.isNew) {
                loggingService.log(this.isDebug, 'CRSelectionUndertaking', 'New undertaking, skipping the loading of CR list')
                return
            }
            return undertakingService.listCulturalResources(this.$http, this.undertaking.undertakingId).then(response => {
                loggingService.log(this.isDebug, 'CRSelectionUndertaking', 'CR List: ' + response.data.length)
                this.siteList = response.data
                return response
            })
        },
        showSearch () {
            this.crSearchDto = {}
            this.searchGridSpec.tableData = []
            this.noSearchResults = false
            this.$refs['culturalResourceSearchModal'].open()
        },
        searchCulturalResource () {
            loggingService.log(this.isDebug, 'CRSelectionUndertaking', `Searching`)
            this.crSearchLoading = true
            culturalResourceService.search(this.$http, this.crSearchDto).then(response => {
                this.searchGridSpec.tableData = response.data
                this.noSearchResults = (response.data.length === 0)
                this.crSearchLoading = false
                loggingService.log(this.isDebug, 'CRSelectionUndertaking', 'Search complete: ' + response.data.length)
            })
        },
        addCulturalResource  (culturalResource) {
            loggingService.log(this.isDebug, 'CRSelectionUndertaking', `Adding CR to list: ${culturalResource}`)
            var newCR = {
                undertakingId: this.undertaking.undertakingId,
                culturalResourceId: culturalResource.culturalResourceId,
                eligibilityId: culturalResource.currentEligibilityId,
                timePeriodId: culturalResource.timePeriodId,
                siteTypeId: culturalResource.siteTypeId,
                effectId: ''
            }
            undertakingService.setCulturalResource(this.$http, newCR).then(response => {
                this.loadSelectionList()
            })
            this.$refs['culturalResourceSearchModal'].close()
        },
        setEffect (culturalResourceId, event, propName) {
            loggingService.log(this.isDebug, 'CRSelectionUndertaking', `CR id: ${culturalResourceId}, new effect id: ${event.target.value}`)
            var site = this.siteList.find(x => {
                return x.culturalResourceId === culturalResourceId
            })
            if (site) {
                site[propName] = Number(event.target.value)
            }
        },
        submit () {
            //do nothing
        },
        save () {
            if (window.confirm('You are about to save your selections. Do you want to continue?')) {
                loggingService.log(this.isDebug, 'CRSelectionUndertaking', 'Saving List')
                this.siteList.forEach(x => {
                    loggingService.log(this.isDebug, 'CRSelectionUndertaking', `Saving ${x.smithsonianNumber} with effect ${x.effectId}`)
                    undertakingService.setCulturalResource(this.$http, x)
                }).then(response => {
                    this.loadSelectionList()
                })
            }
        },
        deleteResource (crr) {
            if (confirm(`Are you sure you wish to delete site ${crr.smithsonianNumber}?`)) {
                if (crr.undertakingCulturalResourceId) {
                    undertakingService.deleteCulturalResource(this.$http, crr.undertakingCulturalResourceId).then(response => {
                        this.crrValidationResult = response.data
                        this.loadSelectionList()
                    })
                } else {
                    this.loadSelectionList()
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// CulturalResourceSelectionUndertaking.vue?6ea54006